<template>
  <v-card
    elevation="2"
    :style="{
      height: '350px',
      overflow: 'auto',
    }"
  >
    <v-fab-transition>
      <v-btn
        :loading="loadingDownload"
        class="mx-2"
        fab
        dark
        small
        color="green"
        :style="{
          position: 'absolute',
          top: '0',
          right: '0',
          margin: '10px',
          'z-index': '2',
        }"
        @click="downloadThePDF()"
      >
        <v-icon dark> mdi-download </v-icon>
      </v-btn>
    </v-fab-transition>
    <pdf ref="pdfSK" :src="pdfData" />
  </v-card>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  components: { pdf: () => import('vue-pdf') },
  props: ['id', 'pdfData', 'pdfType'],
  data() {
    return {
      loadingDownload: false,
    };
  },
  methods: {
    async downloadThePDF() {
      if (this.pdfType == 'pdfNib') {
        const { view } = this.$route.params;
        switch (view) {
          case 'inputer-list':
          case 'approver-1-list':
          case 'approver-2-list':
            await this.setDownloadThePDF(1);
            break;
          case 'inputer-history-list':
          case 'approver-1-history-list':
          case 'approver-2-history-list':
            await this.setDownloadThePDF(2);
            break;
          default:
            this.$router.back();
            break;
        }
      } else {
        await this.setDownloadThePDF(1);
      }
    },
    async setDownloadThePDF(type) {
      this.loadingDownload = true;
      await this.$store
        .dispatch('daftarTugas/mw/downloadPdf', {
          id: this.id,
          type,
          date,
        })
        .then((status) => {
          if (status) {
            if (window.open(status, '_blank')) {
              setTimeout(() => this.setRemovePdf(type), 5000);
            }
          }
        })
        .finally(() => {
          this.loadingDownload = false;
        });
    },
    setRemovePdf(type) {
      let removeType = 0;
      switch (type) {
        case 1:
          removeType = 3;
          break;
        case 2:
          removeType = 4;
          break;
        default:
          break;
      }
      this.$store.dispatch('daftarTugas/mw/removePdf', {
        id: this.id,
        type: removeType,
        date,
      });
    },
  },
};
</script>
